export const generateBackgroundColor = (stringInput: string) => {
    let stringUniqueHash = stringInput?.split('').reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 3) - acc);
    }, 0);
    return `hsl(${stringUniqueHash % 360}, 75%, 80%)`;
}